import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, Tag, Spin, Alert } from "antd";
import { FileTextOutlined, ClusterOutlined } from "@ant-design/icons";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

// eslint-disable-next-line react/prop-types
function DocumentosAsociados({ numeroCaso, onTicketClick }) {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!numeroCaso) return;
    const fetchDocs = async () => {
      try {
        setLoading(true);
        setError(null);
        const res = await axios.get(
          `https://contratosback.azurewebsites.net/api/v1/ObtenerDocumentosAsociados/${numeroCaso}`
        );
        setDocs(res.data || []);
      } catch (err) {
        console.error(err);
        setError("No se pudieron cargar los documentos asociados.");
      } finally {
        setLoading(false);
      }
    };
    fetchDocs();
  }, [numeroCaso]);

  if (loading) return <Spin size="large" style={{ margin: "20px auto", display: "block" }} />;
  if (error) return <Alert message={error} type="error" showIcon style={{ margin: "10px 0" }} />;
  if (!docs.length) return null;

  return (
    <MDBox mt={4}>
      <MDTypography variant="h6" mb={2}>
        Documentos Asociados<br></br> Verifique si la información que busca se encuentra en los
        tickets asociados.
      </MDTypography>
      {docs.map((doc) => (
        <Card
          key={doc.documents_id}
          style={{
            marginBottom: "20px",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          }}
          title={
            <span style={{ fontSize: "16px", fontWeight: "bold" }}>
              <FileTextOutlined style={{ marginRight: 8, color: "#1890ff" }} />
              {doc.documento}
            </span>
          }
          extra={<span style={{ fontWeight: "500" }}>Tickets: {doc.cantidad_tickets}</span>}
        >
          <MDTypography variant="body2" style={{ marginBottom: "10px" }}>
            <ClusterOutlined style={{ marginRight: 6, color: "#52c41a" }} />
            Tickets Asociados:
          </MDTypography>

          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
            {doc.tickets_asociados.split(",").map((t) => {
              const ticketId = t.trim();
              return (
                <Tag
                  color="blue"
                  key={ticketId}
                  style={{ cursor: "pointer" }}
                  onClick={() => onTicketClick(ticketId)}
                >
                  #{ticketId}
                </Tag>
              );
            })}
          </div>
        </Card>
      ))}
    </MDBox>
  );
}

export default DocumentosAsociados;
